// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Composite API
 * HTTP API for managing Neo4j composite database instances.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelsProvider } from './ModelsProvider';
import {
  ModelsProviderFromJSON,
  ModelsProviderFromJSONTyped,
  ModelsProviderToJSON,
  ModelsProviderToJSONTyped,
} from './ModelsProvider';
import type { ModelsCompositeInstanceStatus } from './ModelsCompositeInstanceStatus';
import {
  ModelsCompositeInstanceStatusFromJSON,
  ModelsCompositeInstanceStatusFromJSONTyped,
  ModelsCompositeInstanceStatusToJSON,
  ModelsCompositeInstanceStatusToJSONTyped,
} from './ModelsCompositeInstanceStatus';

/**
 *
 * @export
 * @interface HandlersCompositeInstanceInternalResponse
 */
export interface HandlersCompositeInstanceInternalResponse {
  /**
   *
   * @type {ModelsProvider}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  cloudProvider?: ModelsProvider;
  /**
   *
   * @type {string}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  compositeDatabaseName?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  deletedAt?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  memory?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  neo4jVersion?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  orchestra?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  projectId?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  region?: string;
  /**
   *
   * @type {ModelsCompositeInstanceStatus}
   * @memberof HandlersCompositeInstanceInternalResponse
   */
  status?: ModelsCompositeInstanceStatus;
}

/**
 * Check if a given object implements the HandlersCompositeInstanceInternalResponse interface.
 */
export function instanceOfHandlersCompositeInstanceInternalResponse(
  value: object,
): value is HandlersCompositeInstanceInternalResponse {
  return true;
}

export function HandlersCompositeInstanceInternalResponseFromJSON(
  json: any,
): HandlersCompositeInstanceInternalResponse {
  return HandlersCompositeInstanceInternalResponseFromJSONTyped(json, false);
}

export function HandlersCompositeInstanceInternalResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlersCompositeInstanceInternalResponse {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider:
      json['cloudProvider'] == null
        ? undefined
        : ModelsProviderFromJSON(json['cloudProvider']),
    compositeDatabaseName:
      json['compositeDatabaseName'] == null
        ? undefined
        : json['compositeDatabaseName'],
    createdAt: json['createdAt'] == null ? undefined : json['createdAt'],
    deletedAt: json['deletedAt'] == null ? undefined : json['deletedAt'],
    id: json['id'] == null ? undefined : json['id'],
    memory: json['memory'] == null ? undefined : json['memory'],
    name: json['name'] == null ? undefined : json['name'],
    neo4jVersion:
      json['neo4jVersion'] == null ? undefined : json['neo4jVersion'],
    orchestra: json['orchestra'] == null ? undefined : json['orchestra'],
    projectId: json['projectId'] == null ? undefined : json['projectId'],
    region: json['region'] == null ? undefined : json['region'],
    status:
      json['status'] == null
        ? undefined
        : ModelsCompositeInstanceStatusFromJSON(json['status']),
  };
}

export function HandlersCompositeInstanceInternalResponseToJSON(
  json: any,
): HandlersCompositeInstanceInternalResponse {
  return HandlersCompositeInstanceInternalResponseToJSONTyped(json, false);
}

export function HandlersCompositeInstanceInternalResponseToJSONTyped(
  value?: HandlersCompositeInstanceInternalResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloudProvider: ModelsProviderToJSON(value['cloudProvider']),
    compositeDatabaseName: value['compositeDatabaseName'],
    createdAt: value['createdAt'],
    deletedAt: value['deletedAt'],
    id: value['id'],
    memory: value['memory'],
    name: value['name'],
    neo4jVersion: value['neo4jVersion'],
    orchestra: value['orchestra'],
    projectId: value['projectId'],
    region: value['region'],
    status: ModelsCompositeInstanceStatusToJSON(value['status']),
  };
}
